import BulkProduct from './BulkProduct';

export default BulkProduct;
